import React from "react";
import { ReactSession } from "../lib/secure_reactsession";
import { ToastMessage } from "./themes/userq/ToastMessage/ToastMessage";
import "./TopDeprecationBanner.css";

export default function TopDeprecationBanner() {
    ReactSession.setStoreType("localStorage");
    const user = ReactSession.get("user");

    // Only show banner for Tester role
    if (!user || user.role !== "Tester") {
        return null;
    }

    return (
        <div className="top-deprecation-banner">
            <ToastMessage
                type="info"
                message="Bank transfer and PayPal will be phased out after Dec 31, 2025"
                closable={false}
                cssClasses="top-deprecation-toast"
            />
        </div>
    );
}

